import type { Brief } from "../../../shared/types";

/**
 * A brief that is drafted with Draft this: ad hoc, created from an idea or a hand-made blog brief.
 * Review's Retry drafts it again from its brief (round-3 P0-2), so it never takes a replacement draft.
 */
export function isDraftThisBrief(brief: Pick<Brief, "cadence_source" | "source_finding_id" | "surface" | "platform">): boolean {
  return brief.cadence_source === "adhoc" && (!!brief.source_finding_id || (brief.surface ?? brief.platform) === "blog");
}
